import { selectDoc, selectAll, event } from "../utils/utils";

import bodymovin from "../lib/lottie.min";

export class CardProduct {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.cardProduct = selectAll("[data-card_product]");
    this.cardsContainer = selectAll(".card-product__item");
  }

  render() {
    this.setLottie();
    this.hoverHandler();
  }

  setLottie = () => {
    const cardProduct = this.cardProduct;
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    const isMobile = window.innerWidth < 768;

    for (var i = 0; i < cardProduct.length; i++) {
      const id = cardProduct[i].id;
      const element = document.getElementById(`bm-${id}`);
      const elementImg = document.getElementById(`bm-img-${id}`);
      const path = cardProduct[i].getAttribute("data-card_product");

      if (path !== "") {
        if (isMobile) {
          element.classList.add("hidden");
          elementImg.classList.remove("hidden");
        } else {
          let animation = bodymovin.loadAnimation({
            container: element,
            renderer: "svg",
            loop: true,
            autoplay: false,
            path: path,
          });
  
          if (!isFirefox) {
            event(cardProduct[i], "mouseover", function () {
              animation.play();
            });
  
            event(cardProduct[i], "mouseleave", function () {
              animation.pause();
            });
          }
        }
      }
    }
  };

  hoverHandler = () => {
    this.cardsContainer.forEach((card) => {
      const badge = card.querySelector(".card-product__badge");
      const figure = card.querySelector("figure") ? card.querySelector("figure") : card.querySelector("img");

      figure.addEventListener("mouseenter", (e) => {
        if (badge) {
          badge.classList.add("invert");
        }
      });
      figure.addEventListener("mouseleave", (e) => {
        if (badge) {
          badge.classList.remove("invert");
        }
      });
    });
  };
}
